/* eslint-disable no-unused-vars */
import Vue from 'vue';
import _ from 'lodash';
import {
    GET_CARS_DETAIL_REQUEST,
    GET_CARS_DETAIL_SUCCESS,
    GET_CARS_DETAIL_FAILURE,
    UPDATE_CARS_DETAIL_PARAMS,
    RESOLVE_CARS_DETAIL_PARAMS,
    GET_CARS_DETAIL_CAR_LIST_PARAMS,
    GET_CARS_DETAIL_CAR_LIST_SUCCESS,
    GET_CARS_DETAIL_CAR_LIST_FAILURE,
    RESOLVE_CARS_DETAIL_CAR_LIST_PARAMS,
    SAVE_CAR_DETAIL_REQUEST,
    SAVE_CAR_DETAIL_SUCCESS,
    SAVE_CAR_DETAIL_FAILURE,
    RESOLVE_SAVE_CAR_DETAIL_PARAMS,
    CAR_DETAIL_RESET_DATA,
    GET_MAINTAIN_LIST_SUCCESS,
    DELETE_MAINTAIN_ITEM
} from '../mutationTypes';

const state = {
    engineNum: '', // v3.5新增发动机型号字段
    frameNum: '', // v3.5新增车架号字段
    loading: false,
    page: 1,
    pageSize: 10,
    carNo:'',
    carRemark: '',
    modelId: '',
    driveMileage:'',
    companyId: '',
    companyName: '',
    carVerifyDate: '',
    carInsuranceDate: '',
    carDate: {
        carBrandId: '',
        carLineId: '',
        vehicle_id: '',
    },
    listData: [],
    listData2: [],
    pageCount: 1,
    carInfoReqParams: {},
    userListReqParams: {},
    saveCarDetailReqParams: {},
    errorMsg: ''
};

const mutations = {
    [GET_CARS_DETAIL_REQUEST](state) {
        state.loading = true;
    },
    [GET_CARS_DETAIL_SUCCESS](state, res) {
        state.loading = false;
        state.carDate = res;
        state.driveMileage = res.driveMileage;
        state.modelId = res.vehicle_id;
        state.carRemark = res.carRemark;
        state.companyId = res.companyId;
        state.companyName = res.companyName;
        state.carVerifyDate = res.carVerifyDate;
        state.carInsuranceDate = res.carInsuranceDate;
        state.engineNum = res.engineNum;
        state.frameNum = res.frameNum;
    },
    [GET_CARS_DETAIL_FAILURE](state) {
        state.loading = false;
        state.carDate = {};
    },
    [UPDATE_CARS_DETAIL_PARAMS](state, params) {
        const {
            carNo, page, modelId, driveMileage, carRemark, companyId, companyName, carVerifyDate, carInsuranceDate, engineNum, frameNum
        } = params;
        if (engineNum) state.engineNum = engineNum;
        if (frameNum) state.frameNum = frameNum;
        if (carNo || carNo === '') state.carNo = carNo;
        if (companyId || companyId === '') state.companyId = companyId;
        if (companyName || companyName === '') state.companyName = companyName;
        console.log(carVerifyDate, typeof (carVerifyDate), carVerifyDate === '');
        if (carVerifyDate || carVerifyDate === '' || typeof (carVerifyDate) === 'object') state.carVerifyDate = carVerifyDate;
        if (carInsuranceDate || carInsuranceDate === '' || typeof (carInsuranceDate) === 'object') state.carInsuranceDate = carInsuranceDate;
        if (modelId || modelId === '') state.modelId = modelId;
        if (driveMileage || typeof (driveMileage) === 'undefined' || driveMileage === 0) state.driveMileage = driveMileage;
        if (carRemark || carRemark === '') state.carRemark = carRemark;
        if (page) {
            state.page = page; // 分页要进行请求
        }
    },
    [RESOLVE_CARS_DETAIL_PARAMS](state, reqParams) {
        state.carInfoReqParams = reqParams;
    },
    [GET_CARS_DETAIL_CAR_LIST_PARAMS](state) {
        state.loading = true;
    },
    [GET_CARS_DETAIL_CAR_LIST_SUCCESS](state, res) {
        state.loading = false;
        state.pageCount = res.page_count;
        state.listData = res.user_list;
    },
    [GET_CARS_DETAIL_CAR_LIST_FAILURE](state) {
        state.loading = false;
        state.pageCount = 1;
        state.listData = [];
    },
    [RESOLVE_CARS_DETAIL_CAR_LIST_PARAMS](state, reqParams) {
        state.userListReqParams = reqParams;
    },
    [SAVE_CAR_DETAIL_REQUEST](state) {
        state.loading = true;
    },
    [SAVE_CAR_DETAIL_SUCCESS](state) {
        state.errorMsg = '';
        state.loading = false;
    },
    [SAVE_CAR_DETAIL_FAILURE](state, msg) {
        state.loading = false;
        state.errorMsg = msg;
    },
    [RESOLVE_SAVE_CAR_DETAIL_PARAMS](state, reqParams) {
        state.saveCarDetailReqParams = reqParams;
    },
    [CAR_DETAIL_RESET_DATA](state) {
        _.extend(state, _.cloneDeep({
            engineNum: '',
            frameNum: '',
            loading: false,
            page: 1,
            pageSize: 10,
            carNo:'',
            carRemark: '',
            modelId: '',
            driveMileage:'',
            companyId: '',
            companyName: '',
            carVerifyDate: '',
            carInsuranceDate: '',
            carDate: {
                carBrandId: '',
                carLineId: '',
                vehicle_id: ''
            },
            listData: [],
            pageCount: 1,
            carInfoReqParams: {},
            userListReqParams: {},
            saveCarDetailReqParams: {}
        }));
    },
    [GET_MAINTAIN_LIST_SUCCESS](state, list) {
        state.listData2 = list;
    },
    [DELETE_MAINTAIN_ITEM](state, index) {
        state.listData2.splice(index, 1);
    }
};

export const actions = {
    async getCarsDetail({ commit }) {
        commit(GET_CARS_DETAIL_REQUEST);
        const res = await Vue.$ajax.get('carDetail', state.carInfoReqParams);
        if (!res.errorType) {
            commit(GET_CARS_DETAIL_SUCCESS, res);
        } else {
            commit(GET_CARS_DETAIL_FAILURE);
        }
    },
    resolveCarsDetailParams({ commit }) {
        const params = {};
        params.car_no = state.carNo;
        commit(RESOLVE_CARS_DETAIL_PARAMS, params);
    },
    async getCarsDetailUserCarList({ commit }) {
        commit(GET_CARS_DETAIL_CAR_LIST_PARAMS);

        const res = await Vue.$ajax.get('userList', state.userListReqParams);
        if (!res.errorType) {
            commit(GET_CARS_DETAIL_CAR_LIST_SUCCESS, res);
        } else {
            commit(GET_CARS_DETAIL_CAR_LIST_FAILURE);
        }
    },
    async updateCompanyName({ commit }, valObj) {
        const COMPANY_CACHE = JSON.parse(localStorage.getItem('COMPANY_CACHE'));
        const companyList = COMPANY_CACHE.data.companyList;
        let flag = false;
        companyList.forEach((item) => {
            if (item.companyName === valObj.companyName) {
                flag = true;
            }
        });
        if (flag === false) {
            companyList.push(valObj);
            COMPANY_CACHE.data.companyList = companyList;
        }
        localStorage.setItem('COMPANY_CACHE', JSON.stringify(COMPANY_CACHE));
    },
    async getMaintainList({ commit }, carNo) {
        // 查询预计下次保养列表信息
        const res = await Vue.$ajax.post('getMaintainList', {car_no: state.carNo || carNo});
        let errmsg = '';
        if (!res.errcode && !res.errorType) {
            commit(GET_MAINTAIN_LIST_SUCCESS, res);
        } else {
            errmsg = res.errmsg;
        }
        return errmsg;
    },
    resolveCarsDetailUserCarListParams({ commit }) {
        const params = _.pick(state, ['page']);
        params.pagesize = state.pageSize;
        params.car_no = state.carNo;
        commit(RESOLVE_CARS_DETAIL_CAR_LIST_PARAMS, params);
    },
    async saveCarDetailParams({ commit }) {
        commit(SAVE_CAR_DETAIL_REQUEST);
        const res = await Vue.$ajax.get('carEdit', state.saveCarDetailReqParams);
        if (!res.errcode && !res.errorType) {
            commit(SAVE_CAR_DETAIL_SUCCESS, res);
        } else { // 请求失败
            console.log(res.errmsg);
            commit(SAVE_CAR_DETAIL_FAILURE, res.errmsg);
        }
    },
    resolveSaveCarDetailParams({ commit }) {
        const params = {};
        params.vehicle_id = state.modelId;
        params.driveMileage = state.driveMileage;
        params.companyId = state.companyId;
        params.companyName = state.companyName;
        params.carVerifyDate = state.carVerifyDate;
        params.carInsuranceDate = state.carInsuranceDate;
        params.vehicle_remark = state.modelId ? '' : state.carRemark;
        params.plateNum = state.carNo;
        params.engineNum = state.engineNum;
        params.frameNum = state.frameNum;
        commit(RESOLVE_SAVE_CAR_DETAIL_PARAMS, params);
    },
    deleteMaintainItem({ commit }, index) {
        commit(DELETE_MAINTAIN_ITEM, index);
    }
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/carsDetail.js